import { useEffect, useState } from "react";
import api from "../../services/api";
import { normalizeParticipant } from "./mentions";

// Participantes do grupo, carregados uma vez por conversa e divididos entre a lista de
// mensagens (nome nas menções) e o campo de mensagem (sugestões ao digitar "@").
// A consulta vai ao WhatsApp, então o resultado fica guardado por alguns minutos.

const TTL = 5 * 60 * 1000;
const cache = new Map(); // contactId -> { at, promise, list }

const load = (contactId) => {
  const key = String(contactId);
  const cached = cache.get(key);
  if (cached && Date.now() - cached.at < TTL) return cached.promise;
  const entry = { at: Date.now(), list: null, promise: null };
  entry.promise = api
    .get(`/contacts/${contactId}/participants`)
    .then(({ data }) => {
      entry.list = (Array.isArray(data) ? data : []).map(normalizeParticipant).filter(Boolean);
      return entry.list;
    })
    .catch(() => {
      // WhatsApp desconectado ou grupo sem metadados: segue sem nomes e tenta de novo depois
      cache.delete(key);
      return [];
    });
  cache.set(key, entry);
  return entry.promise;
};

// { participants, loaded }: loaded vira true quando a consulta terminou (com ou sem sucesso).
const useGroupParticipants = (contactId) => {
  const [state, setState] = useState({ contactId: null, participants: [], loaded: false });

  useEffect(() => {
    if (!contactId) {
      setState({ contactId: null, participants: [], loaded: false });
      return undefined;
    }
    let cancelled = false;
    const cached = cache.get(String(contactId));
    setState({ contactId, participants: (cached && cached.list) || [], loaded: !!(cached && cached.list) });
    load(contactId).then((list) => {
      if (!cancelled) setState({ contactId, participants: list, loaded: true });
    });
    return () => {
      cancelled = true;
    };
  }, [contactId]);

  return state.contactId === contactId ? state : { contactId, participants: [], loaded: false };
};

export default useGroupParticipants;
